import { render, staticRenderFns } from "./WishSuccess.vue?vue&type=template&id=e0d4c75c&scoped=true&"
import script from "./WishSuccess.vue?vue&type=script&lang=js&"
export * from "./WishSuccess.vue?vue&type=script&lang=js&"
import style0 from "./WishSuccess.vue?vue&type=style&index=0&id=e0d4c75c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d4c75c",
  null
  
)

export default component.exports